import React from 'react'

export default function Step4Footer({
  rows, goBack, caseValidation, warningsAcknowledged,
  setWarningsAcknowledged, onSolicitarGenerarCalculo,
  canGenerarCalculo, calculoLoading, COINS_POR_CALCULO,
  motivoBloqueoCalculo, calculoFetchError, setCalculoFetchError,
  asistidoMode,
}) {
  return (
    <>
      <div className="mt-3 flex items-center justify-between gap-2">
        <button type="button" onClick={goBack} className="rounded-xl border border-white/30 bg-white/10 px-4 py-2 text-sm font-semibold text-white">Anterior</button>
        <div className="flex items-center gap-2">
          {caseValidation.warnings.length > 0 && (
            <div className="max-w-2xl rounded-lg border border-amber-300/50 bg-amber-500/20 p-3 text-xs text-amber-100">
              <p className="font-semibold uppercase tracking-wide">Atencion Pericial</p>
              <ul className="mt-1 list-disc pl-4">
                {caseValidation.warnings.map((warn, idx) => <li key={`warn-${idx}`}>{warn}</li>)}
              </ul>
              {!warningsAcknowledged && (
                <button
                  type="button"
                  onClick={() => setWarningsAcknowledged(true)}
                  className="mt-2 rounded border border-amber-200/60 bg-amber-100/10 px-2 py-1 text-[11px] font-semibold text-amber-50"
                >
                  Entiendo el impacto y deseo continuar
                </button>
              )}
            </div>
          )}
          <button
            type="button"
            onClick={onSolicitarGenerarCalculo}
            disabled={!asistidoMode && (!canGenerarCalculo || (caseValidation.warnings.length > 0 && !warningsAcknowledged))}
            className="btn-profile-soft rounded-xl px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40"
          >
            {calculoLoading ? 'Generando cálculo...' : `Generar cálculo (${COINS_POR_CALCULO} Coins)`}
          </button>
        </div>
      </div>
      {!asistidoMode && !canGenerarCalculo && motivoBloqueoCalculo && (
        <p className="mt-2 text-right text-xs text-profile-warn">{motivoBloqueoCalculo}</p>
      )}
      {calculoFetchError && (
        <div className="mt-2 flex items-start gap-2 rounded-lg border border-rose-300/50 bg-rose-500/20 p-3 text-xs text-rose-100">
          <span className="flex-1">{calculoFetchError}</span>
          <button type="button" onClick={() => setCalculoFetchError('')} className="text-rose-200 hover:text-rose-50">✕</button>
        </div>
      )}
    </>
  )
}
